/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import type { BadgeContainerProps } from './types';

// This type definition is based on packages/design-system/atlassian-navigation/src/components/BadgeContainer/index.tsx
// It has been introduced for the Nav4 migration and supersedes the BadgeProps type definition in the same file and is
// replicates the original navigation styling.

const badgeContainerStyles = css({
	position: 'absolute',
	insetBlockStart: `${token('space.negative.050', '-4px')}`,
	insetInlineEnd: `${token('space.negative.025', '-2px')}`,
	pointerEvents: 'none',
});

const containerStyles = css({
	position: 'relative',
});

export const BadgeContainer = (props: BadgeContainerProps) => {
	const { id: badgeId, badge: Badge, children, role } = props;
	return (
		<div css={containerStyles} role={role}>
			{children}
			<div css={badgeContainerStyles} id={badgeId} aria-hidden>
				<Badge />
			</div>
		</div>
	);
};
